<template>
	<div class="check-list-view">
		<div v-for="(opt, i) in options" :key="i" class="item">
			{{ opt.label }}
			<switch-view :value="value.includes(opt.value)" @input="switchInput(opt.value, $event)" />
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			},
			options: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			switchInput(id, state) {
				if (state) {
					this.add(id);
				} else {
					this.remove(id);
				}
			},
			add(id) {
				if (!this.value.includes(id)) {
					var value = Array.from(this.value);
					value.push(id);
					this.$emit('input', value);
				}
			},
			remove(id) {
				this.$emit('input', this.value.filter(function (v) {
					return v != id;
				}));
			}
		}
	}
</script>

<style lang="scss" scoped>
	.check-list-view {
		padding: 0;
		margin: 0;

		& > .item {
			position: relative;
			line-height: 30px;
			position: relative;
			padding: 10px 0 10px 20px;
			border-top: 1px solid #2d2f36;

			& > .switch {
				position: absolute;
				top: 15px;
				right: 15px;
			}
		}
	}
</style>